import {
    StyleSheet
} from "react-native";
import type {
    BreadcrumbListDynamicStyleType
} from "./type";

const stylesheet = StyleSheet.create({
    measure: {
        pointerEvents: "none",
        position: "absolute",
        opacity: 0
    },
    container: {
        flexDirection: "row",
        alignItems: "center",
        flexShrink: 1
    }
});

export const useStyles = ({
    spaces
}: BreadcrumbListDynamicStyleType) => {
    return {
        container: {
            gap: spaces.spacingSm
        }
    };
};
export default stylesheet;
